// 엑셀 (.xlsx/.xls/.xlsm/.xlsb) + CSV/PSV/SAM. 서버 files.ts 의 TABULAR_EXTS 와 동기.
// 한 곳이 늘어나면 양쪽 다 늘려야 한다.
export const TABULAR_EXTS = ['.xlsx', '.xls', '.xlsm', '.xlsb', '.csv', '.psv', '.sam'];

// 변환해 분석하는 비정형 문서. 서버 files.ts 의 DOCUMENT_EXTS 와 동기.
// .doc/.ppt(구 Office)는 LibreOffice 설치 환경에서만 서버 allowedExts 에 포함된다.
export const DOCUMENT_EXTS = [
  '.pdf',
  '.hwp',
  '.hwpx',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.md',
  '.txt',
];

export function isTabularName(name: string): boolean {
  const lower = name.toLowerCase();
  return TABULAR_EXTS.some((ext) => lower.endsWith(ext));
}

export function isDocumentName(name: string): boolean {
  const lower = name.toLowerCase();
  return DOCUMENT_EXTS.some((ext) => lower.endsWith(ext));
}

/** 첨부 분석 가능한 파일(표 형식 + 문서) 인지. */
export function isAttachableName(name: string): boolean {
  return isTabularName(name) || isDocumentName(name);
}

/** input[accept] 속성용 — 표 형식 + 문서 전체. */
export const ATTACH_ACCEPT_ATTR = [...TABULAR_EXTS, ...DOCUMENT_EXTS].join(',');

/** 파일명 확장자 (점 없는 소문자). 없으면 ''. */
function extOf(name: string): string {
  const dot = name.lastIndexOf('.');
  return dot < 0 || dot === name.length - 1 ? '' : name.slice(dot + 1).toLowerCase();
}

/**
 * 서버가 내려준 허용 확장자 목록(점 없는 소문자, DRM 반영) 기준 검사.
 * exts 가 비어있으면(미로딩) 전체 첨부 가능 형식으로 fallback.
 */
export function isAllowedName(name: string, exts: readonly string[] | undefined): boolean {
  if (!exts || exts.length === 0) return isAttachableName(name);
  return exts.includes(extOf(name));
}

/** 서버 허용 확장자 목록 → input[accept] 속성 (".xlsx,.pdf,..."). 비면 전체 fallback. */
export function acceptAttrFor(exts: readonly string[] | undefined): string {
  if (!exts || exts.length === 0) return ATTACH_ACCEPT_ATTR;
  return exts.map((e) => `.${e}`).join(',');
}

export const UNSUPPORTED_FILE_TYPE_MESSAGE = '분석할 수 없는 파일 형식입니다.';
